import MultiSelect from './MultiSelect.container';

export default MultiSelect;
